"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanvaDownloadFailedNotification = exports.getFetchHubUsersFailedNotification = exports.getFetchSignedURLFailedNotification = exports.getThumbnailFolderNetworkRequestFailedNotification = exports.getVideoThumbnailNetworkRequestFailedNotification = exports.getAnimatedGifVideoThumbnailFailureNotification = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var getAnimatedGifVideoThumbnailFailureNotification = function getAnimatedGifVideoThumbnailFailureNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.animatedGifVideoThumbnail.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.animatedGifVideoThumbnail.error.message')
  };
};

exports.getAnimatedGifVideoThumbnailFailureNotification = getAnimatedGifVideoThumbnailFailureNotification;

var getVideoThumbnailNetworkRequestFailedNotification = function getVideoThumbnailNetworkRequestFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.videoThumbnail.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.videoThumbnail.error.message')
  };
};

exports.getVideoThumbnailNetworkRequestFailedNotification = getVideoThumbnailNetworkRequestFailedNotification;

var getThumbnailFolderNetworkRequestFailedNotification = function getThumbnailFolderNetworkRequestFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.videoThumbnailFolder.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.videoThumbnailFolder.error.message')
  };
};

exports.getThumbnailFolderNetworkRequestFailedNotification = getThumbnailFolderNetworkRequestFailedNotification;

var getFetchSignedURLFailedNotification = function getFetchSignedURLFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.fetchSignedURL.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.fetchSignedURL.error.message')
  };
};

exports.getFetchSignedURLFailedNotification = getFetchSignedURLFailedNotification;

var getFetchHubUsersFailedNotification = function getFetchHubUsersFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.fetchHubUsers.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.fetchHubUsers.error.message')
  };
};

exports.getFetchHubUsersFailedNotification = getFetchHubUsersFailedNotification;

var getCanvaDownloadFailedNotification = function getCanvaDownloadFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.upload.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.upload.error.message')
  };
};

exports.getCanvaDownloadFailedNotification = getCanvaDownloadFailedNotification;